import { useState } from "react";
import { Loader2, LogIn } from "lucide-react";
import { FULL_LOGO_URL } from "@/components/site/Logo";
import { formatApiError } from "@/lib/api";
import InstallPWAButton from "@/components/InstallPWAButton";

export const EmployeeSystemLogin = ({ onLogin, sessionError }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const submit = async (event) => {
        event.preventDefault();
        setBusy(true);
        setError("");
        try { await onLogin(email, password); }
        catch (err) { setError(formatApiError(err)); }
        finally { setBusy(false); }
    };
    return (
        <div className="h-full flex flex-col justify-center px-6 bg-slate-50" data-testid="employee-system-login">
            <img src={FULL_LOGO_URL} alt="MyServiceHelper" className="h-8 w-full object-contain mb-6" />
            <h1 className="text-2xl font-bold text-slate-900 text-center" data-testid="employee-system-login-title">Medarbejdersystem</h1>
            <p className="text-sm text-slate-500 text-center mt-2 mb-6" data-testid="employee-system-login-subtitle">Log ind på din virksomhedskonto</p>
            <form onSubmit={submit} className="space-y-4" data-testid="employee-system-login-form">
                <div>
                    <label htmlFor="employee-system-email" className="text-sm font-semibold text-slate-600 block mb-1">Email</label>
                    <input id="employee-system-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="employee-system-login-email"
                        className="w-full h-11 rounded-xl border border-slate-200 px-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none" placeholder="medarbejder@firma.dk" />
                </div>
                <div>
                    <label htmlFor="employee-system-password" className="text-sm font-semibold text-slate-600 block mb-1">Adgangskode</label>
                    <input id="employee-system-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="employee-system-login-password"
                        className="w-full h-11 rounded-xl border border-slate-200 px-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>
                {(error || sessionError) && <p role="alert" data-testid="employee-system-login-error" className="text-sm text-red-700 break-words">{error || sessionError}</p>}
                <button type="submit" disabled={busy} data-testid="employee-system-login-submit" className="w-full h-11 rounded-xl bg-blue-600 text-white text-sm font-bold flex items-center justify-center gap-2 hover:bg-blue-700 transition-colors disabled:opacity-50">
                    {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} {busy ? "Logger ind…" : "Log ind"}
                </button>
            </form>
            <a href="/glemt-adgangskode" target="_blank" rel="noopener noreferrer" data-testid="employee-system-forgot-password" className="mt-5 text-center text-sm text-blue-600 hover:underline">Glemt adgangskode?</a>
            <InstallPWAButton className="mt-4 w-full h-11 rounded-xl border border-slate-200 text-slate-700 bg-white" label="Hent app" />
        </div>
    );
};